import * as React from 'react'
import { LabelIconSpanConnected } from './LabelIconSpanConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const LabelIconSpanExamples = () => {
  return (
    <div className="LabelIconSpanExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <LabelIconSpanConnected labelId={'123'} />
      </Provider>
    </div>
  )
}
